import {
    getUsers,
    getColdUsers,
    getSubscriberUsers,
    restoreUser,
    deleteUser,
    forceDeleteUser,
    userShow,
    userScans,
    userEmailDetails,
    userEmailLog,
    getReport,
    getTinderReport,
    getReportImage,
    updateUser,
    getUserPayments,
    createUser,
    getDisputeReport,
    resendVerification,
    getTrashedUsers,
} from '../../api/users'

import {
    downloadFile,
} from '../../servises/downloadFile'
import {
    Message
} from 'element-ui'
import router from '../../router/'

const state = {
    users: [],
    trashedUsers: [],
    meta: [],
    trashedUsersMeta: [],
    coldUsers:[],
    coldMeta: [],
    subscriberUsers: [],
    subscriberMeta: [],
    reportStatus: {},
    searchParams: '',
    userShow: {},
    userScans: {},
    userEmailDetails: {},
    userEmailLog: {},
    reportData: [],
    reportInfo: {},
    userPayments: [],
    userPaymentsMeta: [],
    disputeReport: {},
}

const getters = {
    users: state => state.users,
    usersMeta: state => state.meta,
    trashedUsers: state => state.trashedUsers,
    trashedUsersMeta: state => state.trashedUsersMeta,
    coldUsers: state => state.coldUsers,
    coldMeta: state => state.coldMeta,
    subscriberUsers: state => state.subscriberUsers,
    subscriberMeta: state => state.subscriberMeta,
    reportStatus: state => state.reportStatus,
    searchParams: state => state.searchParams,
    userShow: state => state.userShow,
    userScans: state => state.userScans,
    userEmailDetails: state => state.userEmailDetails,
    userEmailLog: state => state.userEmailLog,
    userPayments: state => state.userPayments,
    userPaymentsMeta: state => state.userPaymentsMeta,
    reportData: state => state.reportData,
    reportInfo: state => state.reportInfo,
    disputeReport: state => state.disputeReport
}

const mutations = {
    SET_USER: (state, data) => {
        state.users = data.data
        state.meta = data.meta
    },
    SET_TRASHED_USER: (state, data) => {
        state.trashedUsers = data.data
        state.trashedUsersMeta = data.meta
    },
    SET_COLD_USER: (state, data) => {
      state.coldUsers = data.data
      state.coldMeta = data.meta
    },
    SET_SUBSCRIBER_USER: (state, data) => {
      state.subscriberUsers = data.data
      state.subscriberMeta = data.meta
    },
    SET_SEARCH_PARAM: (state, data) => {
        state.searchParams = data
    },
    SET_REPORT_LOADING: (state, data) => {
        state.reportStatus = data
    },
    SET_USER_SHOW: (state, payload) => {
        state.userShow = payload
    },
    SET_USER_PAYMENTS: (state, payload) => {
        state.userPayments = payload.data
        state.userPaymentsMeta = payload.meta
    },
    SET_USER_SCANS: (state, payload) => {
        state.userScans = payload
    },
    SET_USER_EMAIL_DETAILS:(state, payload) => {
        state.userEmailDetails = payload
    },
    SET_USER_EMAIL_LOG:(state, payload) => {
        state.userEmailLog = payload
    },
    SET_REPORT: (state, payload) => {
        state.reportData = payload.reportData
        state.reportInfo = payload.reportInfo
    },
    SET_TINDER_REPORT: (state, payload) => {
        state.reportData = payload.reportData
        state.reportInfo = payload.reportInfo
    },
    CLEAR_REPORT: state => {
        state.reportData = []
    },
    SET_DISPUTE_REPORT: (state, payload) => {
        state.disputeReport = payload
    },
}

const actions = {
    getUsers: ({
        commit
    }, pl) => {
        commit('SET_SEARCH_PARAM', pl)
        getUsers(pl).then(r => {
            commit('SET_USER', r)
        })
    },
    getTrashedUsers: ({commit}, pl) => {
        commit('SET_SEARCH_PARAM', pl);
        getTrashedUsers(pl).then(r => {
            commit('SET_TRASHED_USER', r)
        })
    },
    restoreUser: ({
        commit,
        dispatch
    }, pl) => {
        restoreUser(pl).then(r => {
            dispatch('getTrashedUsers', state.searchParams)
        }).catch(err => {
            console.error(err)
        })
    },
    deleteUser: ({
        commit,
        dispatch
    }, pl) => {
        deleteUser(pl).then(r => {
            dispatch('getUsers', state.searchParams)
        }).catch(err => {
            console.dir(err)
        })
    },
    forceDeleteUser: ({commit, dispatch}, pl) => {
        forceDeleteUser(pl).then(() => {
            dispatch('getTrashedUsers', state.searchParams)
        }).catch(err => {
            console.error(err)
        })
    },
    userShow: ({
        commit,
        dispatch
    }, idUser) => {
        userShow(idUser).then(r => {
            commit('SET_USER_SHOW', r)
        }).catch(err => {
            if (err.response.status === 404) {
                console.log(router.push({
                    name: 'not-found'
                }))
            }
        });
    },
    userEmailDetails: async ({
        commit,
        dispatch
    }, email) => {
        return await userEmailDetails({"email":email}).then(r => {
                commit('SET_USER_EMAIL_DETAILS', r)
            }).catch(err => {
                commit('SET_USER_EMAIL_DETAILS', {})
            });
    },

    userEmailLog: ({commit, dispatch}, pr) => {
        return userEmailLog(pr).then(r => {
            commit('SET_USER_EMAIL_LOG', r)
        }).catch(err => {
            commit('SET_USER_EMAIL_LOG', {})
        });
    },

    userReports: ({
        commit,
        dispatch
    }, idUser, pr) => {
        dispatch('getUserScans', {
          userId: idUser,
          pr
      })
    },

    getUserPayments: ({
        commit,
        dispatch
    }, userId) => {
        return getUserPayments(userId).then(r => {
            commit('SET_USER_PAYMENTS', r);
            return Promise.resolve(true);
        }).catch(err => console.dir(err))
    },

    getUserScans: ({
        commit,
        state
    }, pl) => {
        if (!pl.userId) {
            pl.userId = state.userShow.id
        }
        return userScans(pl).then(r => {
            commit('SET_USER_SCANS', r)
            return Promise.resolve(pl);
        }).catch(err => console.dir(err))
    },

    getReport: ({
        commit
    }, choiseReport) => {
        getReport(choiseReport.id).then(r => {
            commit('SET_REPORT', {
                reportData: r.data,
                reportInfo: choiseReport,
            })
        }).catch(err => console.dir(err))
    },

    getDisputeReport: ({
        commit
    }, params) => {
        return new Promise((resolve, reject)=>{
            getDisputeReport(params).then(r => {
                commit('SET_DISPUTE_REPORT', r)
                return resolve(r)
            }).catch(err => console.dir(err))
        }).catch(err => console.dir(err))
    },

    getTinderReport: ({
        commit
    }, choiseReport) => {
        getTinderReport(choiseReport.id).then(r => {
            commit('SET_TINDER_REPORT', {
                reportData: r.data,
                reportInfo: choiseReport,
            })
        }).catch(err => console.dir(err))
    },

    clearReport: ({
        commit
    }) => {
        commit('CLEAR_REPORT')
    },
    downloadImage({
        state,
        commit
    }, pl) {

        let id
        if (pl) {
            id = pl.id
        } else {
            id = state.reportInfo.id
        }
        commit('SET_REPORT_LOADING', {
            isLoading: true,
            reportId: id
        })
        getReportImage(pl.download_url).then(resp => {
            downloadFile(resp.data, `report_${id}.pdf`)
            commit('SET_REPORT_LOADING', {
                isLoading: false,
                reportId: ''
            })
        }).catch(err => {
            console.dir(err)
        })
    },
    downloadPDF({
        state
    }, pl) {
        let id
        if (pl) {
            id = pl.id
        } else {
            id = state.reportInfo.id
        }

        getReportPDF(id).then(resp => {
            downloadFile(resp)
        }).catch(err => {
            console.dir(err)
        })
    },
    updateUser: async ({
        commit
    }, pl) => {
        try {
            const r = await updateUser(pl.id, pl.data)
            Message({
                message: 'User data updated',
                type: 'success',
                duration: 5 * 1000,
                showClose: true,
            })
            return r
        } catch (err) {
            return err
        }
    },
    resendVerification: async ({
                           commit
                       }, pl) => {
        try {
            const resp = await resendVerification(pl.id)
            Message({
                message: resp.message,
                type: resp.status,
                duration: 5 * 1000,
                showClose: true,
            })
            return r
        } catch (err) {
            return err
        }
    },
    clearCurrentUser: ({
        commit
    }, payload = {}) => {
        commit('SET_USER_SHOW', payload)
    },
    createUser: ({
        commit
    }, payload) => {

        return new Promise((resolve, reject) => {
            createUser(payload).then(r => {
                resolve(r)
                Message({
                    message: 'User has been created',
                    type: 'success',
                    duration: 5 * 1000,
                    showClose: true,
                })

            }).catch(err => {
                let arrErrors = err.response.data.errors
                let errors = ''
                for (let itm in arrErrors) {
                    errors = `${errors} \n ${arrErrors[itm][0]}`
                }
                Message({
                    message: errors,
                    type: 'error',
                    duration: 5 * 1000,
                    showClose: true,
                })
            })
        })
    },
    getColdUsers: ({
                   commit
               }, pl) => {
        commit('SET_SEARCH_PARAM', pl)
        getColdUsers(pl).then(r => {
            commit('SET_COLD_USER', r)
        })
    },
     getSubscriberUsers: ({
                   commit
               }, pl) => {
        commit('SET_SEARCH_PARAM', pl)
         getSubscriberUsers(pl).then(r => {
            commit('SET_SUBSCRIBER_USER', r)
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
